<template>
  <AdminLayout><UserHomeTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import UserHomeTable from './UserHomeTable.vue';

export default {
  name: 'UserHome',
  components: { AdminLayout, UserHomeTable },
};
</script>
